import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  CircularProgress,
  makeStyles
} from '@material-ui/core';
import { alpha } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    zIndex: 401,
    backgroundColor: alpha('#fff', 0.5),
  },
});

const TableLoading = ({ size }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <CircularProgress color="secondary" size={size} />
    </Box>
  );
};

TableLoading.propTypes = {
  size: PropTypes.number,
};

TableLoading.defaultProps = {
  size: 64,
};

export default TableLoading;
